import { Grid } from '@mui/material';
import { navigateToSelectedChannelRoute } from 'utils/history';
import { useIntl } from 'react-intl';
import { useSelectedLinkContext } from 'contexts';
import Route from 'routes/Routes';
import { trackEvent, GACommonEventAction, GAEventCategory } from 'services/googleAnalytics';
import useNoWebUserLinkSnackbar from 'hooks/useNoWebUserLinkSnackbar';
import {communicate, help, organize, share} from 'assets/category_cards/home';
import HomeCategory from './HomeCategory';

type HomeCategory = {
  image: string;
  labelId: string;
  route: Route;
  disableIfNoSelectedLink?: boolean;
}

const HOME_CATEGORIES: HomeCategory[] = [
  {
    image: communicate,
    labelId: 'category.communicate.label',
    route: Route.COMMUNICATE,
  },
  {
    image: share,
    labelId: 'category.share.label',
    route: Route.SHARE,
    disableIfNoSelectedLink: true,
  },
  {
    image: organize,
    labelId: 'category.organize.label',
    route: Route.ORGANIZE,
    disableIfNoSelectedLink: true,
  },
  {
    image: help,
    labelId: 'category.help.label',
    route: Route.HELP,
  },
];

const HomeCategories = (): JSX.Element => {
  const intl = useIntl();
  const { selectedLink } = useSelectedLinkContext();
  const showNoWebUserLinkSnackbar = useNoWebUserLinkSnackbar(selectedLink);

  const createCategoryClickHandler = (route: Route, eventLabel: string, options = {disableIfNoSelectedLink: false}) => () => {
    const {disableIfNoSelectedLink} = options;
    if (disableIfNoSelectedLink && !selectedLink) {
      showNoWebUserLinkSnackbar();
    } else {
      trackEvent(
        GAEventCategory.CATEGORY,
        GACommonEventAction.CLICK,
        eventLabel,
      );
      navigateToSelectedChannelRoute(selectedLink, route);
    }
  };

  return (
    <Grid container alignItems="baseline">
      {HOME_CATEGORIES.map(({image, labelId, route, disableIfNoSelectedLink}: HomeCategory) => {
        const label = intl.formatMessage({ id: labelId });
        return (
          <HomeCategory
            key={labelId}
            image={image}
            alt={label}
            onClick={createCategoryClickHandler(route, label, {disableIfNoSelectedLink})}
          />
        )
      })}
    </Grid>
  );
};

export default HomeCategories;